<script lang="ts">
  import ArrowIcon from '$lib/assets/icons/ArrowIcon.svelte';
  import { VIEW_ALL } from '$lib/constants/text';
  import type { ComponentType } from 'svelte';

  export let href: string;
  export let color = 'var(--color-title-light)';
  export let viewAllIcon: ComponentType = ArrowIcon;
  export let handleClick: () => void;
</script>

<a {href} style="--text-color: {color}" on:click={handleClick}>
  {VIEW_ALL}
  <svelte:component this={viewAllIcon} fill={color} />
</a>

<style>
  a {
    text-decoration: none;
    color: var(--color-text-secondary);
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-medium);
    line-height: var(--font-normal-height);
  }
</style>
